import { ColorEnum } from '@/constants/color'
import { DrawerRoute } from '@/features/navigation/drawer/types'
import OpenTabsIcon from '@/features/openTabs/icons/OpenTabsIcon'
import OrdersDrawerBadge from '@/features/orders/components/OrdersDrawerBadge'
import ArchiveIcon from '@/features/ui/icons/components/ArchiveIcon'
import DeliveryIcon from '@/features/ui/icons/components/DeliveryIcon'
import PhoneIcon from '@/features/ui/icons/components/PhoneIcon'
import PosIcon from '@/features/ui/icons/components/PosIcon'
import SettingsIcon from '@/features/ui/icons/components/SettingsIcon'
import ShiftCloseoutIcon from '@/features/ui/icons/components/ShiftCloseoutIcon'

export const routes: readonly DrawerRoute[] = [
    {
        name: 'orders',
        title: ({ t }) => t('drawerItem.orders'),
        Icon: ({ size }) => <DeliveryIcon width={size} height={size} fill={ColorEnum.WHITE} />,
        Badge: OrdersDrawerBadge,
        section: 'top',
        order: 10,
        visible: () => true,
        color: ColorEnum.BRICK_600,
    },
    {
        name: 'pos',
        title: ({ t }) => t('drawerItem.pos'),
        Icon: ({ size }) => <PosIcon width={size} height={size} fill={ColorEnum.WHITE} />,
        section: 'top',
        order: 20,
        visible: () => true,
        color: ColorEnum.BRICK_600,
    },
    {
        name: 'phone',
        title: ({ t }) => t('drawerItem.phone'),
        Icon: ({ size }) => <PhoneIcon width={size} height={size} fill={ColorEnum.WHITE} />,
        section: 'top',
        order: 30,
        visible: () => true,
        color: ColorEnum.BRICK_600,
    },
    {
        name: 'open-tabs',
        title: ({ t }) => t('drawerItem.openTabs'),
        Icon: ({ size }) => <OpenTabsIcon width={size} height={size} fill={ColorEnum.WHITE} />,
        section: 'top',
        order: 40,
        visible: () => true,
        color: ColorEnum.BRICK_600,
    },
    {
        name: 'archive',
        title: ({ t }) => t('drawerItem.archive'),
        Icon: ({ size }) => <ArchiveIcon width={size} height={size} fill={ColorEnum.WHITE} />,
        section: 'top',
        order: 50,
        visible: () => true,
        color: ColorEnum.BRICK_600,
    },
    {
        name: 'shift-closeouts',
        reselectHref: '/shift-closeouts',
        title: ({ t }) => t('drawerItem.shiftCloseouts'),
        Icon: ({ size }) => <ShiftCloseoutIcon size={size} />,
        section: 'top',
        order: 50,
        visible: () => true,
        color: ColorEnum.BRICK_600,
    },
    {
        name: 'settings',
        title: ({ t }) => t('drawerItem.settings'),
        Icon: ({ size }) => <SettingsIcon width={size} height={size} fill={ColorEnum.WHITE} />,
        section: 'bottom',
        order: 100,
        visible: ({ layout }) => layout !== 'compact',
    },
] as const
